import { render } from "./AspirationSection.vue?vue&type=template&id=505f2a48"
import script from "./AspirationSection.vue?vue&type=script&lang=js"
export * from "./AspirationSection.vue?vue&type=script&lang=js"

import "./AspirationSection.vue?vue&type=style&index=0&id=505f2a48&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__